import { render, staticRenderFns } from "./PersonalityNew.vue?vue&type=template&id=32544016&scoped=true&"
import script from "./PersonalityNew.vue?vue&type=script&lang=js&"
export * from "./PersonalityNew.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityNew.vue?vue&type=style&index=0&id=32544016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32544016",
  null
  
)

export default component.exports